import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { InvoiceProcessingStagesDto } from 'src/generated/services/TFinancialApi';
import { tFinancialService } from 'src/infra/services/tFinancialService';
import { cacheKeysUtil } from 'src/utils/cacheKeysUtil';

export const useProcessingStages = (invoiceId?: string): UseQueryResult<InvoiceProcessingStagesDto> =>
  useQuery(
    cacheKeysUtil.getProcessingStages(invoiceId),
    async (): Promise<InvoiceProcessingStagesDto> => {
      const response = await tFinancialService.api.getProcessingStages(invoiceId);
      const { data } = response;
      return data.data || {};
    },
    { enabled: !!invoiceId }
  );
